var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import './CaenTool.scss';
import CaenActivitySection from '../CaenActivitySection/CaenActivitySection';
import axios from 'axios';
import CaenCodeSection from '../CaenCodeSection/CaenCodeSection';
import { Spin } from 'antd';
import CaenDocuments from '../CaenDocuments/CaenDocuments';
var CaenTool = function () {
    var _a = useState(undefined), selectedActivity = _a[0], setSelectedActivity = _a[1];
    var activityRef = useRef(null);
    var inputRef = useRef(null);
    var _b = useState(undefined), activities = _b[0], setActivities = _b[1];
    var _c = useState(false), isCaenLoading = _c[0], setIsCaenLoading = _c[1];
    var _d = useState(), caenCodes = _d[0], setCaenCodes = _d[1];
    var handleInputBlur = function () {
        setTimeout(function () {
            activityRef.current.scrollIntoView({ behavior: 'smooth' });
        }, 50);
    };
    useEffect(function () {
        axios
            .get('/api/caen/activities')
            .then(function (resp) {
            return setTimeout(function () {
                setActivities(resp.data);
            }, 300);
        })
            .catch(function (err) { return console.error(err); });
    }, []);
    useEffect(function () {
        if (selectedActivity !== undefined) {
            setIsCaenLoading(true);
            axios
                .get('/api/caen/codes?ActivityId=' + selectedActivity.Id)
                .then(function (resp) {
                setTimeout(function () {
                    setCaenCodes(resp.data);
                    setIsCaenLoading(false);
                }, 300);
            })
                .catch(function (err) { return console.error(err); });
        }
    }, [selectedActivity]);
    var handleSelectActivity = function (activity) {
        if (document.activeElement === inputRef.current) {
            inputRef.current.focus();
        }
        else {
            activityRef.current.scrollIntoView({ behavior: 'smooth' });
        }
        if (activity === undefined) {
            setCaenCodes(undefined);
        }
        setSelectedActivity(activity);
    };
    var renderCaenCodesAndDocuments = function () {
        if (caenCodes && caenCodes.length > 0) {
            if (selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.Documents) {
                return (_jsxs(_Fragment, { children: [_jsx(CaenCodeSection, { caenCodes: caenCodes }), _jsx(CaenDocuments, { documents: selectedActivity.Documents })] }));
            }
            else {
                return _jsx(CaenCodeSection, { caenCodes: caenCodes });
            }
        }
    };
    return (_jsxs("div", __assign({ className: "caen", ref: activityRef }, { children: [_jsx(CaenActivitySection, { activities: activities, onActivitySelect: handleSelectActivity, inputRef: inputRef, handleInputBlur: handleInputBlur }), isCaenLoading && (_jsx("div", __assign({ className: "caen-activity__spin-center" }, { children: _jsx(Spin, {}) }))), renderCaenCodesAndDocuments()] })));
};
export default CaenTool;
